import styled from 'styled-components';

import { Checkbox } from '@/core/components/Checkbox';

export const CheckboxWrapper = styled.label`
  position: relative;
  display: flex;
  width: 100%;
  margin: 10px;
  cursor: pointer;

  svg {
    margin-right: 11px;
  }

  input {
    opacity: 0;
    width: 0;
  }
`;

interface FormRadioInputProps {
  checked: boolean;
  color: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label: string;
}

export const FormRadioInput = ({
  checked,
  color,
  onChange,
  name,
  label,
}: FormRadioInputProps) => (
  <CheckboxWrapper>
    <Checkbox
      checked={checked}
      color={color}
    />
    <span>{label}</span>
    <input
      type="checkbox"
      name={name}
      value="phone"
      onChange={onChange}
      checked={checked}
    />
  </CheckboxWrapper>
);
